import { render } from "./Academy.vue?vue&type=template&id=5e223528"
import script from "./Academy.vue?vue&type=script&lang=js"
export * from "./Academy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Academy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e223528"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e223528', __exports__)) {
    api.reload('5e223528', __exports__)
  }
  
  module.hot.accept("./Academy.vue?vue&type=template&id=5e223528", () => {
    api.rerender('5e223528', render)
  })

}


export default __exports__